import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.dto.UserInfo';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class UserInfo extends RpcClass{

    /**
     *  @class UserInfo
     *  @alias module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo
     *  
     * */
    constructor(){
        super();

        /** @type {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser}  */
        this.applicationUser = null;
        /** @type {string}  */
        this.connectionCountry = null;
        /** @type {string}  */
        this.connectionCountryCode = null;
        /** @type {string}  */
        this.csrfToken = null;
        /** @type {string}  */
        this.defaultInterfaceLanguageCode = null;
        /** @type {string}  */
        this.defaultLanguageCode = null;
        /** @type {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}  */
        this.featureFlags = null;
        /** @type {boolean}  */
        this.isAdmin = null;
        /** @type {module:src/server/com/silkplm/model/users/ModulesConfiguration.ModulesConfiguration}  */
        this.modulesConfiguration = null;
        /** @type {string}  */
        this.organizationSetupProgress = null;
        /** @type {string}  */
        this.organizationSubscriptionType = null;
        /** @type {number[]}  */
        this.permissionCodes = null;
        /** @type {string}  */
        this.publicSessionId = null;
        /** @type {string}  */
        this.subscriptionStatus = null;
        /** @type {number}  */
        this.unreadNotificationsCount = null;
        /** @type {module:src/server/com/silkplm/model/users/UserNotification.UserNotification[]}  */
        this.unseenNotifications = null;
        /** @type {number}  */
        this.unseenNotificationsCount = null;
        /** @type {string}  */
        this.userSubscriptionType = null;

    }





    /**
     * @param val {module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withApplicationUser(val){
        this.applicationUser = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withConnectionCountry(val){
        this.connectionCountry = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withConnectionCountryCode(val){
        this.connectionCountryCode = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withCsrfToken(val){
        this.csrfToken = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withDefaultInterfaceLanguageCode(val){
        this.defaultInterfaceLanguageCode = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withDefaultLanguageCode(val){
        this.defaultLanguageCode = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withFeatureFlags(val){
        this.featureFlags = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withIsAdmin(val){
        this.isAdmin = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/users/ModulesConfiguration.ModulesConfiguration}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withModulesConfiguration(val){
        this.modulesConfiguration = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withOrganizationSetupProgress(val){
        this.organizationSetupProgress = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withOrganizationSubscriptionType(val){
        this.organizationSubscriptionType = val;
        return this;
    };


    /**
     * @param val {number[]}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withPermissionCodes(val){
        this.permissionCodes = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withPublicSessionId(val){
        this.publicSessionId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withSubscriptionStatus(val){
        this.subscriptionStatus = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withUnreadNotificationsCount(val){
        this.unreadNotificationsCount = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/users/UserNotification.UserNotification[]}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withUnseenNotifications(val){
        this.unseenNotifications = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withUnseenNotificationsCount(val){
        this.unseenNotificationsCount = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo}
     */
    withUserSubscriptionType(val){
        this.userSubscriptionType = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['applicationUser'] = {'remoteType' : 'module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser', 'jsType' : 'module:src/server/com/silkplm/model/users/ApplicationUser.ApplicationUser', 'mapped' : 'false'};
metadata['connectionCountry'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['connectionCountryCode'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['csrfToken'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['defaultInterfaceLanguageCode'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['defaultLanguageCode'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['featureFlags'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'jsType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'mapped' : 'false'};
metadata['isAdmin'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['modulesConfiguration'] = {'remoteType' : 'module:src/server/com/silkplm/model/users/ModulesConfiguration.ModulesConfiguration', 'jsType' : 'module:src/server/com/silkplm/model/users/ModulesConfiguration.ModulesConfiguration', 'mapped' : 'false'};
metadata['organizationSetupProgress'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['organizationSubscriptionType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['permissionCodes'] = {'remoteType' : 'number[]', 'jsType' : 'number[]', 'mapped' : 'false'};
metadata['publicSessionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['subscriptionStatus'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['unreadNotificationsCount'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['unseenNotifications'] = {'remoteType' : 'module:src/server/com/silkplm/model/users/UserNotification.UserNotification[]', 'jsType' : 'module:src/server/com/silkplm/model/users/UserNotification.UserNotification[]', 'mapped' : 'false'};
metadata['unseenNotificationsCount'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['userSubscriptionType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.rpc.dto.UserInfo';
metadata.__type_short__ = 'UserInfo';
UserInfo.prototype.__metadata__ = metadata;

UserInfo.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/dto/UserInfo */
export default UserInfo

export { UserInfo }
